import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { StopImpersonateDocument } from './stop-impersonate.generated';

export const useStopImpersonate = (options: ApiOptions<typeof StopImpersonateDocument> = {}) => {
  const { t } = useTranslation();

  return useMutation(StopImpersonateDocument, {
    ...useNotifications(StopImpersonateDocument, {
      failure: t('api.users.stop_impersonate_error'),
      success: t('api.users.stop_impersonate_success'),
    }),
    ...options,
  });
};
